import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { H1 } from '../../components/basic/Text';
import { useMessageGetter } from 'react-message-context';
import PaddedContent from '../../components/housing/PaddedContent';
import DebtTable from './DebtTable';
import PageContainer from '../PageContainer';
import { RouteComponentProps } from 'react-router-dom';
import Loader from '../../components/basic/Loader';
import { LOAD_STATES } from '../../context/common';
import { useKennoTenant } from '../../context/kennoTenantContext';
import { loadDebt } from '../../context/kennoTenantActions';
import { Body2, LinkButton } from '../../components/common';
import { showNotification } from '../../context/appActions';
import { NotificationType, useAppDispatch, useAppState } from '../../context/appContext';
import { shouldHideFinancialInfo } from '../../utils';
import { MaintenanceNote } from '../../components/FinancialInfoMaintenanceNote';
import { ButtonContainer } from '../layoutComponents';
import { getMenuItemPathBySlug } from '../../utils/wordpress';
import { Slugs } from '../../constants/knownSlugs';

const DebtBackground = styled.div``;

const PayTypeContainer = styled.div`
  margin-bottom: 50px;
`;

const LinkContainer = styled(ButtonContainer)`
  margin-bottom: 40px;
`;

const DebtPage = ({ history }: RouteComponentProps) => {
  const t = useMessageGetter('debt');
  const { menu } = useAppState();
  const [{ debt }, dispatch] = useKennoTenant();
  const appDispatch = useAppDispatch();

  const isLoading = () => {
    return debt.loadState === LOAD_STATES.BUSY;
  };

  useEffect(() => {
    loadDebt(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (debt.loadState === LOAD_STATES.ERROR) {
      showNotification(appDispatch, t('error'), NotificationType.ERROR);
    }
  }, [debt.loadState]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  // Note: temporary implementation, only for Kenno launch, can be removed once
  // Y-Säätiö has confirmed financials in Kenno are correct
  if (shouldHideFinancialInfo()) {
    return (
      <PageContainer history={history}>
        <PaddedContent>
          <H1>{t('title')}</H1>
          <MaintenanceNote translationKey="financial.generic" />
        </PaddedContent>
      </PageContainer>
    );
  }

  // TODO: Find out if we can get this from Kenno
  /*   const printInvoice = () => {
    signAwsUrl(AWSEndpoints.BILLING_DEBT_INVOICE, (signedUrl) => {
      window.open(signedUrl);
      ReactGA.event({
        category: 'Debt page',
        action: 'Print debt invoice',
        label: '/asuntoni/maksut/velkaerittely',
      });
    });

    return false;
  }; */

  const DebtContent = () => {
    return (
      <>
        <DebtBackground>
          <PaddedContent>
            <H1>{t('title')}</H1>
            <Body2>{t('description')}</Body2>
            {debt.data && (
              <PayTypeContainer className="table">
                <DebtTable debt={debt} />
                {/* {!state.debts || state.debts.inProceedings || state.debts.inDistraint ? null : (
                <ButtonContainer>
                  <PrintButton onClick={printInvoice} aria-labelledby="printLabel">
                    <Label id="printLabel">{t('print')}</Label>
                    <img src={printIcon} alt="printer" />
                  </PrintButton>
                </ButtonContainer>
              )} */}
              </PayTypeContainer>
            )}
            <LinkContainer>
              <LinkButton to={getMenuItemPathBySlug(menu.items, Slugs.PAYMENT)} primary iconRight icon="arrowForward">
                {t('goToPayment')}
              </LinkButton>
              <LinkButton to={getMenuItemPathBySlug(menu.items, Slugs.BILLING)}>{t('goToBilling')}</LinkButton>
            </LinkContainer>
            <Body2>{t('contact.description')}</Body2>
            <Body2>{t('contact.description2')}</Body2>
          </PaddedContent>
        </DebtBackground>
      </>
    );
  };

  return (
    <>
      <PageContainer history={history}>{isLoading() ? <Loader /> : <DebtContent />}</PageContainer>
    </>
  );
};

export default DebtPage;
